<template>
    <div class="col-xl-12 float-left background-fff mb-3 roi-widget order-logs padding15">
        <h6 class="proxima-nova-bold float-left">Logs</h6>
        <ul id="comments" style="max-height: 280px; clear: both">
            <li v-for="log in logs">
                <div class="row">
                    <div class="avatar col-sm-2">
                        <img
                            :src="log.user_id !== 0 ? log.user.image  : '/images/robot.png'"
                            :alt="log.user_id !== 0 ? log.user.name  : 'Robot'"
                        />
                    </div>
                    <div class="col-sm-10">
                        <h6>
                            {{ log.user_id !== 0 ? log.user.name  : 'System' }}
                            has {{ log.event }} {{ log.model_name }}
                        </h6>
                        <span class="date mt-0 d-block">
                            {{ log.created_at | formatDate }}
                        </span>
                        <div v-if="log.event === 'created'" class="d-block mt-2">
                            <template v-for="attribute in fetchAttributes(null, log.changed_attributes)">
                                <template v-if="typeof(attribute.newValue) === 'string' && attribute.newValue.startsWith('{') && attribute.newValue.endsWith('}')" style="display: block">
                                    <span>{{ attribute.key }}:</span>
                                    <span v-for="nestedAttribute in fetchAttributes(null, attribute.newValue)" style="display: block; padding-left: 10px">
                                        {{ nestedAttribute.key }}: {{ nestedAttribute.newValue }}
                                    </span>
                                </template>
                                <span v-else style="display: block">
                                    {{ attribute.key }}: {{ attribute.newValue }}
                                </span>
                            </template>
                        </div>
                        <div v-else-if="log.event === 'updated'" class="d-block mt-2">
                            <template v-for="attribute in fetchAttributes(log.original_attributes, log.changed_attributes)">
                                <template v-if="typeof(attribute.newValue) === 'string' && attribute.newValue.startsWith('{') && attribute.newValue.endsWith('}')" style="display: block">
                                    <span>{{ attribute.key }}:</span>
                                    <span v-for="nestedAttribute in fetchAttributes(attribute.oldValue, attribute.newValue)" style="display: block; padding-left: 10px">
                                        {{ nestedAttribute.key }}: {{ nestedAttribute.oldValue }} -> {{ nestedAttribute.newValue }}
                                    </span>
                                </template>
                                <span v-else style="display: block">
                                    {{ attribute.key }}: {{ attribute.oldValue }} -> {{ attribute.newValue }}
                                </span>
                            </template>
                        </div>
                    </div>
                </div>
            </li>
            <li v-if="logs.length === 0" class="m-0 pt-2 border-0" style="text-align: center;margin: 35px;margin-bottom: 7px">
                There are no logs yet!
            </li>
        </ul>
        <div class="clearfix"></div>
        <div class="float-right mt-3 mb-3">
            <pager v-if="total > itemsPerPage" :total="total" :items-per-page="itemsPerPage" :current-page="currentPage" @on-page-change="onPageChange" />
        </div>
    </div>
</template>

<script>
import moment from 'moment';

export default {
    props: ['orderNumber'],
    data: function () {
        return {
            logs: [],
            total: 0,
            currentPage: 0,
            itemsPerPage: 0,
        };
    },
    mounted() {
        this.loadlogs(1);
    },
    methods: {
        loadlogs(page) {
            this.$http.get(`/orders/${this.orderNumber}/logs?page=${page}`).then((res) => {
                this.logs = res.data.data;
                this.total = res.data.total;
                this.currentPage = res.data.current_page;
                this.itemsPerPage = res.data.per_page;
            });
        },
        onPageChange(page) {
            this.loadlogs(page);
        },
        fetchAttributes(originalAttributes, changedAttributes) {
          const ret = [];
          let oldArr = {};
          if (originalAttributes !== null) {
              oldArr = JSON.parse(originalAttributes);
          }
          const newArr = JSON.parse(changedAttributes);
          Object.keys(newArr).forEach((key) => {
              ret.push({
                  key,
                  oldValue: oldArr.hasOwnProperty(key) ? oldArr[key] : null,
                  newValue: newArr[key],
              });
          });

          return ret;
        },
    },
    filters: {
        formatDate(date) {
            return `${moment(date).format('MMM Do HH:mm')} (${moment(date).fromNow()})`;
        }
    }
}
</script>

<style scoped>
.order-logs ul {
    margin: 0;
    padding: 0;
    list-style: none;
}

.order-logs ul li {
    padding: 10px;
    border-bottom: 2px solid #f1f2f4;
}

.order-logs ul li, .order-logs ul li a {
    float: left;
    width: 100%;
}

.order-logs ul li a {
    display: block;
}

.order-logs ul li:nth-child(2n) {
    background-color: #FAFBFD;
}

.order-logs .date {
    color: #999;
    font-size: 10px;
    line-height: 12px;
}
</style>
